
export const ERROR_MESSAGES = {
  INVALID_APPROVER: 'Invalid approver or not found.',
};

const cleanErrorString = (value) => {
  const message = String(value || '').trim();
  const pythonListMatch = message.match(/^\[['"](.+)['"]\]$/);
  return pythonListMatch ? pythonListMatch[1] : message;
};

const normalizeErrorValue = (value) => {
  if (typeof value === 'string' || typeof value === 'number') {
    return cleanErrorString(value);
  }
  if (Array.isArray(value)) {
    return value.map(normalizeErrorValue).filter(Boolean).join(' ');
  }
  if (value && typeof value === 'object') {
    const preferredKeys = [
      'Invoice Creation Failed with error',
      'detail',
      'error',
      'message',
      'non_field_errors'
    ];
    for (const key of preferredKeys) {
      if (value[key] !== undefined) {
        const message = normalizeErrorValue(value[key]);
        if (message) return message;
      }
    }
    return Object.values(value).map(normalizeErrorValue).filter(Boolean).join(' ');
  }
  return '';
};

/**
 * Extracts error message from various API error response structures
 * @param {Object} error - The error object from axios
 * @returns {string} - The extracted error message
 */
export const extractErrorMessage = (error) => {
  return (
    normalizeErrorValue(error?.response?.data) ||
    cleanErrorString(error?.message) ||
    'An error occurred'
  );
};

/**
 * Checks if the error matches any of the specified error messages
 * @param {Object} error - The error object from axios
 * @param {string|string[]} errorMessages - Single error message or array of error messages to check
 * @returns {boolean} - True if the error matches any of the specified messages
 */
export const isErrorType = (error, errorMessages) => {
  const messages = Array.isArray(errorMessages) ? errorMessages : [errorMessages];
  const extractedMessage = extractErrorMessage(error);
  
  return messages.includes(extractedMessage);
};

/**
 * Checks if the error is an OTP approval error that should not show a toast
 * @param {Object} error - The error object from axios
 * @returns {boolean} - True if it's an OTP approval error
 */
export const isOTPApprovalError = (error) => {
  return isErrorType(error, ERROR_MESSAGES.INVALID_APPROVER);
};
